import ButtonExtended from 'components/ButtonExtended'
import { SRPRS } from 'Icon/srprs'
import * as React from 'react'
import { Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { Giftcard } from '../../data/models/giftcard'
import { AppState } from '../../data/state'
import Content from '../../pages/shared/content'

interface GiftcardButtonProps {
  giftCards: Giftcard[]
  openGiftcardModal: () => void
}

const GiftcardButton: React.FC<GiftcardButtonProps> = ({
  giftCards,
  openGiftcardModal,
}) => {
  return (
    <ButtonExtended
      header={
        giftCards.length > 0 ? (
          <Content
            contentKey="giftcard-redeem-remove"
            plural={giftCards.length > 1}
          >
            <Singular>Redeem/remove gift card</Singular>
            <Plural>Redeem/remove gift cards</Plural>
          </Content>
        ) : (
          <Content contentKey="giftcard-redeem">Redeem gift card</Content>
        )
      }
      onClick={openGiftcardModal}
      icon={SRPRS.present}
      i={giftCards.length}
      isActive={giftCards.length > 0}
    />
  )
}

export default connect(
  (state: AppState) => ({ giftCards: state.funnelOrder.giftcards }),
  dispatch => ({
    openGiftcardModal: () => {
      dispatch(actions.change('ui.viewGiftcardModal', true))
    },
  }),
)(GiftcardButton)
